import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../constants-enumerate';
import {deepAssign} from '@aofl/object-utils';
import {dateTimeFormatter} from '@modules/i18n-datetime';

const sdo = {
  namespace: sdoNs.INVENTORY_UPDATE_LOG,
  mutations: {
    init() {
      return {
        sort: {
          limit: 50,
          is_forward: true,
          fields: ['timestamp', 'id'],
        },
        level: 0,
        hasMore: false,
        results: [],
        assignmentLogs: [],
      };
    },
    setData(subState, resp) {
      return {...subState, results: resp.results, hasMore: resp.has_more};
    }
  },
  decorators: [
    (nextState) => { // $distributionLogs
      const currState = storeInstance.getState()[sdoNs.INVENTORY_UPDATE_LOG];
      if (
        typeof nextState[sdoNs.INVENTORY_UPDATE_LOG].$distributionLogs === 'undefined'
        ||
        currState.results !== nextState[sdoNs.INVENTORY_UPDATE_LOG].results
      ) {
        const $distributionLogs = nextState[sdoNs.INVENTORY_UPDATE_LOG].results?.map((log) => {
          log.$date = dateTimeFormatter.format(new Date(log.timestamp * 1000), {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: true
          });
          return log;
        });
        nextState = deepAssign(nextState, sdoNs.INVENTORY_UPDATE_LOG, {$distributionLogs});
      }
      return nextState;
    },
    (nextState) => { // prev pointer items
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.INVENTORY_UPDATE_LOG];
      const subState = state[sdoNs.INVENTORY_UPDATE_LOG];

      if (typeof nextSubState.$prev === 'undefined' || nextSubState.results !== subState.results) {
        let $prev = '';
        if (nextSubState.results.length > 0) {
          $prev = nextSubState.results[0];
        }

        nextState = deepAssign(nextState, `${sdoNs.INVENTORY_UPDATE_LOG}`, {$prev});
      }

      return nextState;
    },
    (nextState) => { // next pointer items
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.INVENTORY_UPDATE_LOG];
      const subState = state[sdoNs.INVENTORY_UPDATE_LOG];

      if (typeof nextSubState.$next === 'undefined' ||
        nextSubState.results !== subState.results) {
        let $next = '';
        if (nextSubState.results.length > 0) {
          $next = nextSubState.results[nextSubState.results.length - 1];
        }

        nextState = deepAssign(nextState, `${sdoNs.INVENTORY_UPDATE_LOG}`, {$next});
      }

      return nextState;
    },
    (nextState) => { // $sort
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.INVENTORY_UPDATE_LOG];
      const subState = state[sdoNs.INVENTORY_UPDATE_LOG];

      if (
        typeof nextSubState.$sort === 'undefined'
        ||
        nextSubState.sort !== subState.sort
      ) {
        const $sort = Object.assign({}, nextSubState.sort);
        if ($sort.direction === '') {
          $sort.direction = 'asc';
        }

        nextState = deepAssign(nextState, sdoNs.INVENTORY_UPDATE_LOG, {
          $sort
        });
      }

      return nextState;
    },
    (nextState) => { // $pageNumber
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.INVENTORY_UPDATE_LOG];
      const subState = state[sdoNs.INVENTORY_UPDATE_LOG];

      if (
        typeof nextSubState.$pageNumber === 'undefined'
        ||
        nextSubState.hasMore !== subState.hasMore
        ||
        nextSubState.$sort !== subState.$sort
      ) {
        const hasOffset = Boolean(nextSubState.$sort.last_values);
        let $pageNumber = 1;
        let $numPages = 3;

        if (nextSubState.$sort.is_forward) {
          if (hasOffset) {
            $pageNumber = 2;
          }

          if (!nextSubState.hasMore) {
            $numPages = $pageNumber;
          }
        } else {
          $pageNumber = nextSubState.hasMore ? 2 : 1;
        }

        nextState = deepAssign(nextState, `${sdoNs.INVENTORY_UPDATE_LOG}`, {$pageNumber, $numPages});
      }

      return nextState;
    },
  ]
};

storeInstance.addState(sdo);
